<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-right`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.4521 3.33496C13.8194 3.33496 14.1171 3.63279 14.1172 4V12C14.1172 12.3673 13.8194 12.665 13.4521 12.665C13.0849 12.665 12.7871 12.3672 12.7871 12V4C12.7872 3.63282 13.085 3.33501 13.4521 3.33496ZM7.38574 4.0293C7.64543 3.76968 8.06746 3.76968 8.32715 4.0293L11.8271 7.5293C12.0868 7.78898 12.0868 8.211 11.8271 8.4707L8.32715 11.9707C8.06745 12.2304 7.64544 12.2304 7.38574 11.9707C7.1261 11.711 7.12606 11.289 7.38574 11.0293L9.75 8.66504H2.54785C2.18058 8.66504 1.88281 8.36727 1.88281 8C1.88288 7.63279 2.18062 7.33496 2.54785 7.33496H9.75L7.38574 4.9707C7.1261 4.711 7.12606 4.28898 7.38574 4.0293Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineRight',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
